<div class="dataField" [formGroup]="formData">
  <div class="row">
    <div class="col-md-6">
      <div class="form-group">
        <label [title]="groupTooltip">Group</label> *
        <div class="input-group">
          <select class="form-control" formControlName="dataFieldGroupsId" (blur)="onTouched()">
            @for (item of dataFieldGroups; track item) {
              <option [ngValue]="item.DataFieldGroupId">
                {{item.DisplayName}}
              </option>
            }
          </select>
          <span class="input-group-btn">
            <button class="btn btn-default" (click)="onEditGroups()" type="button">Edit</button>
          </span>
        </div>
        <div [class.invisible]="!formData.get('dataFieldGroupsId').hasError('min') || formData.get('dataFieldGroupsId').untouched"
          class="error">
          <span>Required</span>
        </div>
      </div>
    </div>
    <div class="col-md-6">
      <div class="form-group">
        <label [title]="typeTooltip">Type</label> *
        <select class="form-control" formControlName="dataTypeId" (blur)="onTouched()">
          @for (item of dataFieldTypes; track item) {
            <option [ngValue]="item.DateTypeId">
              {{item.DataTypeName}}
            </option>
          }
        </select>
        <div [class.invisible]="!formData.get('dataTypeId').hasError('min') || formData.get('dataTypeId').untouched"
          class="error">
          <span>Required</span>
        </div>
      </div>
    </div>
  </div>

  <div class="row">
    @if (showField('displayName')) {
      <div class="col-md-6">
        <div class="form-group">
          <label [title]="displayNameTooltip">Display name</label> *
          <input formControlName="displayName" class="form-control" (blur)="onTouched()" />
          <div [class.invisible]="!formData.get('displayName').hasError('required') || formData.get('displayName').untouched"
            class="error">
            <span>Required</span>
          </div>
        </div>
      </div>
    }
    @if (showField('isRequired')) {
      <div class="col-md-3">
        <div class="form-group">
          <div class="control control-checkbox lg control-form-group">
            <label [title]="isRequiredTooltip">
              Is required
              <input type="checkbox" formControlName="isRequired" class="form-control" (blur)="onTouched()" />
              <i></i>
            </label>
          </div>
        </div>
      </div>
    }
    @if (showField('dataLength')) {
      <div class="col-md-3">
        <div class="form-group">
          <label [title]="dataLengthTooltip">Max length</label> *
          <input formControlName="dataLength" type="number" min="1" max="4000" class="form-control"
            (blur)="onTouched()" />
            <div [class.invisible]="!formData.get('dataLength').hasError('required') || formData.get('dataLength').untouched"
              class="error">
              <span>Required</span>
            </div>
            <div [class.invisible]="!(formData.get('dataLength').hasError('min') || formData.get('dataLength').hasError('max')) || formData.get('dataLength').untouched"
              class="error">
              <span>Out of range</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row">
      @if (showField('regex')) {
        <div class="col-md-6">
          <div class="form-group">
            <label [title]="regexTooltip">RegEx</label>
            <input formControlName="regex" class="form-control" (blur)="onTouched()" />
            <div [class.invisible]="!formData.get('regex').hasError('required') || formData.get('regex').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
      }
      @if (showField('regexText')) {
        <div class="col-md-6">
          <div class="form-group">
            <label [title]="regexTextTooltip">RegEx error</label>
            <input formControlName="regexText" class="form-control" (blur)="onTouched()" />
            <div [class.invisible]="!formData.get('regexText').hasError('required') || formData.get('regexText').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row">
      @if (showField('infoText')) {
        <div class="col-md-12">
          <div class="form-group">
            <label [title]="infoTextTooltip">Information</label>
            <textarea rows="4" formControlName="infoText" class="form-control noresize" (blur)="onTouched()"></textarea>
            <div [class.invisible]="!formData.get('infoText').hasError('required') || formData.get('infoText').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row">
      @if (showField('defaultValue')) {
        <div class="col-md-6">
          <div class="form-group">
            <label [title]="defaultValueTooltip">Default value</label>
            <input formControlName="defaultValue" class="form-control" (blur)="onTouched()" />
            <div [class.invisible]="!formData.get('defaultValue').hasError('required') || formData.get('defaultValue').untouched"
              class="error">
              <span>Required</span>
            </div>
          </div>
        </div>
      }
      @if (showField('sortOrder')) {
        <div class="col-md-6">
          <div class="form-group">
            <label [title]="sortOrderTooltip">Order</label> *
            <input formControlName="sortOrder" type="number" min="1" class="form-control" (blur)="onTouched()" />
            <div [class.invisible]="!formData.get('sortOrder').hasError('required') || formData.get('sortOrder').untouched"
              class="error">
              <span>Required</span>
            </div>
            <div [class.invisible]="!formData.get('sortOrder').hasError('min') || formData.get('sortOrder').untouched"
              class="error">
              <span>Out of range</span>
            </div>
          </div>
        </div>
      }
    </div>

    <div class="row">
      @if (showField('choices')) {
        <div class="col-md-6">
          <div class="form-group">
            <label [title]="choicesTooltip">Choices</label>
            <div class="input-group">
              <select class="form-control" (blur)="onTouched()">
                @for (choice of choices; track choice) {
                  <option>
                    {{ choice.DisplayValue }}
                    @if (choice.IsDefault) {
                      &nbsp;*
                    }
                  </option>
                }
              </select>
              <span class="input-group-btn">
                <button class="btn btn-default" (click)="onEditChoices()" type="button">Edit</button>
              </span>
            </div>
          </div>
        </div>
      }
    </div>
  </div>
